export default __webpack_public_path__ + "static/media/waiting_1.5fea3e1e.png";